import { createAction } from '@reduxjs/toolkit';

import { SET_AUTH_FORM_MODE, type AuthFormMode } from './types';

export const setAuthFormMode = createAction<AuthFormMode, typeof SET_AUTH_FORM_MODE>(SET_AUTH_FORM_MODE);

export type SetAuthFormMode = typeof setAuthFormMode;
